const init = function init() {

};

export default {
  init,
};
